export default "__VITE_ASSET__Vt8x4R90__"